export const MAP = {
  defaultBounds: [-180, -85, 180, 85],
  defaultZoom: 13,
  defaultCenter: [-23.550421, -46.633468],
  options: {
    maxZoom: 20,
  },
};

export const MAP_MOBILE = {
  defaultBounds: [-180, -85, 180, 85],
  defaultZoom: 13,
  defaultCenter: [-23.550421, -46.633468],
  options: {
    maxZoom: 18,
  },
};
